import React from 'react';
import PropTypes from 'prop-types';
import cx from "../utils/styles";
var emptyCallback = function emptyCallback() {
  return undefined;
};
export var CalendarHeader = function CalendarHeader(_ref) {
  var children = _ref.children,
    className = _ref.className,
    onPrevClick = _ref.onPrevClick,
    onNextClick = _ref.onNextClick,
    _ref$isPrevAllowed = _ref.isPrevAllowed,
    isPrevAllowed = _ref$isPrevAllowed === void 0 ? true : _ref$isPrevAllowed,
    _ref$isNextAllowed = _ref.isNextAllowed,
    isNextAllowed = _ref$isNextAllowed === void 0 ? true : _ref$isNextAllowed;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('header', className)
  }, /*#__PURE__*/React.createElement("button", {
    className: cx('button', 'prev', {
      blocked: !isPrevAllowed
    }),
    onClick: isPrevAllowed ? onPrevClick : emptyCallback,
    type: "button"
  }), children, /*#__PURE__*/React.createElement("button", {
    className: cx('button', 'next', {
      blocked: !isNextAllowed
    }),
    onClick: isNextAllowed ? onNextClick : emptyCallback,
    type: "button"
  }));
};
CalendarHeader.propTypes = process.env.NODE_ENV !== "production" ? {
  onPrevClick: PropTypes.func.isRequired,
  onNextClick: PropTypes.func.isRequired,
  isPrevAllowed: PropTypes.bool,
  isNextAllowed: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
} : {};
CalendarHeader.defaultProps = {
  isPrevAllowed: true,
  isNextAllowed: true
};